import { ActivityItemType } from 'entities/promo/types';

export const useUpdatePromoCardDefaultValues = (promoCardData: ActivityItemType) => ({
  id: promoCardData.id,
  name_kz: promoCardData.name.kz,
  name_ru: promoCardData.name.ru,
  name_kg: promoCardData.name.kg,
  name_uz: promoCardData.name.uz,
  name_en: '',
  description_kz: promoCardData.description.kz,
  description_ru: promoCardData.description.ru,
  description_kg: promoCardData.description.kg,
  description_uz: promoCardData.description.uz,
  description_en: '',
  title_before_kz: promoCardData.title_before.kz,
  title_before_ru: promoCardData.title_before.ru,
  title_before_kg: promoCardData.title_before.kg,
  title_before_uz: promoCardData.title_before.uz,
  title_before_en: '',
  description_before_kz: promoCardData.description_before.kz,
  description_before_ru: promoCardData.description_before.ru,
  description_before_kg: promoCardData.description_before.kg,
  description_before_uz: promoCardData.description_before.uz,
  description_before_en: '',
  activity_type_id: promoCardData.activity_type?.id || null,
  reg_start_date: promoCardData.reg_start_date,
  reg_end_date: promoCardData.reg_end_date,
  activity_start_date: promoCardData.activity_start_date,
  activity_end_date: promoCardData.activity_end_date,
  bonus_start_date: promoCardData.bonus_start_date,
  bonus_end_date: promoCardData.bonus_end_date,
  objective_ids: promoCardData.objective_ids,
  participant_ids: promoCardData.participants.map((participant) => participant.participant_id),
  image: promoCardData.image || null,
});
